import { AbilityBuilder, createMongoAbility } from '@casl/ability';

export const defineUserAbilities = (user) => {
  const { can, rules } = new AbilityBuilder(createMongoAbility);

  if (user.userRole === 'Superadmin') {
    can('view', 'TenantList');
  }

  if (user.tenantRole === 'Administrator') {
    can('create', 'Tenant');
    can('edit', 'Tenant');
  }

  if (user.tenantRole === 'AdministratorSpeicherfuchs') {
    can('edit', 'Tenant');
  }

  if (user.tenantRole === 'Viewer') {
  }

  return createMongoAbility(rules);
};
